import { render, staticRenderFns } from "./SocialNetworkHeader.vue?vue&type=template&id=130f16ab&"
import script from "./SocialNetworkHeader.vue?vue&type=script&lang=ts&"
export * from "./SocialNetworkHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports